module.exports = __webpack_public_path__ + "static/img/background.73d9c769.svg";